@if ($labelContainer()) {
  <div class="form-field-label">
    <ng-content select="osp-label"></ng-content>
  </div>
}

<div class="form-field-input">
  <ng-content></ng-content>
</div>

@if ($errorContainer()) {
  <div class="form-field-error">
    <!-- TODO: Apply "error" styles to input and an error message when control is "touched" as well ? -->
    <!-- @if (dirty() || touched()) { -->
    @if ($dirty()) {
      <div class="form-field-error-container">
        <ng-content select="osp-error"></ng-content>
      </div>
    }
  </div>
}
